import { addDaysToDate, lastDateOfMonth, diffDays } from "../utils/date_utils";

const SPECIFIC_PAYMENT_TERMS = {
  END_OF_MONTH: "fdm",
  FORTY_FIVE_DAYS_END_OF_MONTH: "45fdm",
  THIRTY_DAYS_END_OF_MONTH: "30fdm",
};

const isSpecificPaymentTerms = (paymentTerm) => {
  return Object.values(SPECIFIC_PAYMENT_TERMS).includes(paymentTerm);
};

const specificPaymentTermsNumberOfDays = (startDate, paymentTerm) => {
  let dueDay;

  switch (paymentTerm) {
    case SPECIFIC_PAYMENT_TERMS.END_OF_MONTH:
      dueDay = lastDateOfMonth(startDate.getMonth(), startDate.getFullYear());
      break;
    case SPECIFIC_PAYMENT_TERMS.FORTY_FIVE_DAYS_END_OF_MONTH:
      dueDay = addDaysToDate(startDate, 45);
      dueDay = lastDateOfMonth(dueDay.getMonth(), dueDay.getFullYear());
      break;
    case SPECIFIC_PAYMENT_TERMS.THIRTY_DAYS_END_OF_MONTH:
      dueDay = addDaysToDate(startDate, 30);
      dueDay = lastDateOfMonth(dueDay.getMonth(), dueDay.getFullYear());
      break;
  }

  return diffDays(startDate, dueDay);
};

const numberOfDaysUntilDueDate = (startDate, value) => {
  if (isSpecificPaymentTerms(value)) {
    return specificPaymentTermsNumberOfDays(startDate, value);
  }

  return value;
};

const computeDueDate = (startDate, paymentTermsValue) => {
  const numberOfDays = numberOfDaysUntilDueDate(startDate, paymentTermsValue);
  return addDaysToDate(startDate, parseInt(numberOfDays));
};

export { computeDueDate };
